import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['visitor', 'visitor-registration', 'grid--vertical'])
}
const _hoisted_2 = { class: "binding-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_visiting_companies = _resolveComponent("visiting-companies")!
  const _component_visitor_profile = _resolveComponent("visitor-profile")!
  const _component_photo_taker = _resolveComponent("photo-taker")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_code_scanner = _resolveComponent("code-scanner")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_wrapper_footer = _resolveComponent("wrapper-footer")!
  const _component_preview_visitor = _resolveComponent("preview-visitor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_visiting_companies, {
        ref: "visitingCompanies",
        editable: true,
        multiple: true
      }, null, 512),
      _createVNode(_component_el_card, {
        header: _ctx.trans('label.visitor-information')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "form",
            "label-position": "top",
            model: _ctx.model
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(['info', { 'is-mobile': _ctx.mobileVersion }])
              }, [
                _createVNode(_component_visitor_profile, {
                  ref: "visitorProfile",
                  model: _ctx.model
                }, null, 8, ["model"]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_card, { class: "binding-item" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_photo_taker, {
                        ref: "photoTaker",
                        model: _ctx.model
                      }, null, 8, ["model"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "binding-item" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_code_scanner, {
                        ref: "codeScanner",
                        "code-type": 'rfid',
                        model: _ctx.model,
                        validate: true
                      }, null, 8, ["model"])
                    ]),
                    _: 1
                  })
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _createVNode(_component_wrapper_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/dashboard')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveVisitorWithTakePhoto()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.save")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_preview_visitor, { ref: "previewVisitor" }, null, 512)
  ], 64))
}